import { type VivaPlanungConfig } from '@backend-types/AppRouter';
import { z } from 'zod';

export const appConfigJsonSchema = z.strictObject({
  VivaPlanungBackendUrl: z.url(),
  SapAdapterFrontendUrl: z.url(),
  AzureAdTenantId: z.string(),
  AzureAdClientId: z.string(),
  AzureAdRedirectUri: z.string(),
  HiveAppUrl: z.url(),
  AusschreibungsportalUrl: z.url(),
  TaskManagementBoardUrl: z.url(),
  Stage: z.enum(['local', 'dev', 'test', 'prod']),
} satisfies { [K in keyof VivaPlanungConfig]: z.ZodType<unknown, VivaPlanungConfig[K]> });

export type AppConfigJson = z.infer<typeof appConfigJsonSchema>;
